import { render, staticRenderFns } from "./PublicList.vue?vue&type=template&id=52c98f45&"
import script from "./PublicList.vue?vue&type=script&lang=js&"
export * from "./PublicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports